/**
 * V2V Plugin polyfills
 */
import 'core-js/es6/promise';
import 'core-js/es6/set';
import 'core-js/es6/map';
